// =============================================
// BL Accordion — FAQ + Sidebar (One-at-a-Time)
// =============================================
(function() {

  // --- FAQ ---
  const faqItems = document.querySelectorAll('.bl-faq__item details');
  faqItems.forEach((details) => {
    const summary = details.querySelector('summary');
    const answer = details.querySelector('.bl-faq__answer');

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (details._faqAnim) { details._faqAnim.cancel(); details._faqAnim = null; }

      if (details.open) {
        closeItem(details, answer);
      } else {
        faqItems.forEach((other) => {
          if (other !== details && other.open) {
            if (other._faqAnim) { other._faqAnim.cancel(); other._faqAnim = null; }
            closeItem(other, other.querySelector('.bl-faq__answer'));
          }
        });
        openItem(details, answer);
      }
    });
  });

  // --- Sidebar Nav ---
  const navGroups = document.querySelectorAll('.bl-hub__nav-group');

// Init — open group matching URL hash
const hash = window.location.hash.slice(1);
if (hash) {
  navGroups.forEach((g) => {
    const match = g.querySelector(`.bl-hub__nav-link[data-nav-anchor="${hash}"]`);
    if (match) {
      g.setAttribute('open', '');
      const content = g.querySelector('.bl-hub__nav-children');
      if (content) content.style.height = content.scrollHeight + 'px';
    }
  });
}


  navGroups.forEach((details) => {
    const summary = details.querySelector('.bl-hub__nav-toggle');
    const children = details.querySelector('.bl-hub__nav-children');
    if (!summary || !children) return;

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (details._navAnim) { details._navAnim.cancel(); details._navAnim = null; }

      if (details.open) {
        closeNav(details, children);
      } else {
        navGroups.forEach((other) => {
          if (other !== details && other.open) {
            if (other._navAnim) { other._navAnim.cancel(); other._navAnim = null; }
            closeNav(other, other.querySelector('.bl-hub__nav-children'));
          }
        });
        openNav(details, children);
      }
    });
  });

  // --- FAQ helpers ---
  function closeItem(el, content) {
    const a = content.animate(
      { height: [content.offsetHeight + 'px', '0px'], opacity: [1, 0] },
      { duration: 250, easing: 'ease-out', fill: 'forwards' }
    );
    el._faqAnim = a;
    a.onfinish = () => { el.removeAttribute('open'); a.cancel(); el._faqAnim = null; };
  }

  function openItem(el, content) {
    el.setAttribute('open', '');
    const a = content.animate(
      { height: ['0px', content.scrollHeight + 'px'], opacity: [0, 1] },
      { duration: 300, easing: 'ease-out' }
    );
    el._faqAnim = a;
    a.onfinish = () => { el._faqAnim = null; };
  }

  // --- Sidebar helpers ---
  function closeNav(el, content) {
    const a = content.animate(
      { height: [content.offsetHeight + 'px', '0px'] },
      { duration: 250, easing: 'ease-out', fill: 'forwards' }
    );
    el._navAnim = a;
    a.onfinish = () => { el.removeAttribute('open'); content.style.height = ''; a.cancel(); el._navAnim = null; };
  }

  function openNav(el, content) {
    el.setAttribute('open', '');
    content.style.height = 'auto';
    const h = content.scrollHeight + 'px';
    content.style.height = '0px';
    void content.offsetHeight;
    const a = content.animate(
      { height: ['0px', h] },
      { duration: 300, easing: 'ease-out' }
    );
    el._navAnim = a;
    a.onfinish = () => { content.style.height = h; el._navAnim = null; };
  }

})();
